// Footer newsletter: posts straight to Klaviyo's client Subscriptions API rather than
// rendering a Klaviyo embed. The embed needs klaviyo.js, which iubenda's autoblocking
// (and ad blockers) hold back until cookie consent, so visitors who rejected cookies
// never saw the field. A visitor typing their email in and pressing Subscribe is
// their consent to marketing, so this request doesn't wait on the cookie banner.
(function () {
  document.querySelectorAll(".footer-newsletter").forEach(function (form) {
    var row = form.querySelector(".footer-newsletter__row");
    var input = form.querySelector("input[type=email]");
    var btn = form.querySelector("button");
    var msg = form.querySelector(".footer-newsletter__msg");
    var d = form.dataset;
    function show(state, text) { msg.dataset.state = state; msg.textContent = text; msg.hidden = false; }
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var email = input.value.trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { show("error", d.errorInvalid); input.focus(); return; }
      msg.hidden = true; btn.disabled = true;
      var body = {
        data: {
          type: "subscription",
          attributes: {
            custom_source: d.source,
            // The client API rejects a profile `subscriptions` field; joining the list is the opt-in.
            profile: { data: { type: "profile", attributes: { email: email } } }
          },
          relationships: { list: { data: { type: "list", id: d.listId } } }
        }
      };
      fetch("https://a.klaviyo.com/client/subscriptions?company_id=" + encodeURIComponent(d.companyId), {
        method: "POST",
        headers: { "Content-Type": "application/vnd.api+json", revision: "2024-10-15" },
        body: JSON.stringify(body)
      })
        .then(function (r) {
          if (r.ok) { row.hidden = true; show("success", d.success); return; }
          return r.json().catch(function () { return {}; }).then(function (j) {
            var badEmail = (j.errors || []).some(function (err) { return /\/email$/.test((err.source || {}).pointer || ""); });
            btn.disabled = false;
            show("error", badEmail ? d.errorInvalid : d.errorGeneric);
          });
        })
        .catch(function () { btn.disabled = false; show("error", d.errorGeneric); });
    });
  });
})();
